export const DEFAULT_GRID_SIZE = 8;
